import Login from "../views/Login";
import Dashboard from "../views/Dashboard";
import ForgotPasswordMain from "../components/ForgotPassword";
import ProfileTab from "../views/ProfileTab";
import CreateNewPassword from "../views/CreateNewPassword";
import Notification from "../views/Notification";
import PincodeSearch from "../views/PincodeSearch";
import HubSearch from "../views/HubSearch";
import CPSearch from "../views/CPSearch";
import ShipmentDetails from "../views/ShipmentDetailsUI";
import BagDetails from "../views/BagDetailsUi";

import "antd/dist/antd.css";
import "../App.scss";

export const commonRoutes = [
  { 
    component: Login,
    route: "/",
  },
  {
    component: Dashboard,
    route: "/dashboard",
  },
  {
    component: ForgotPasswordMain,
    route: "/forgotPassword",
  },
  {
    component: ForgotPasswordMain,
    route: "/newPassword",
  },
  {
    component: ForgotPasswordMain,
    route: "/confirmpassword",
  },
  {
    component: ForgotPasswordMain,
    route: "/confirmMail",
  },
  {
    component: ProfileTab,
    route: "/profile",
  },
  {
    component: CreateNewPassword,
    route: "/create-new-password",
  },
  {
    component: Notification,
    route: "/notification"
  },
  {
    component: PincodeSearch,
    route: "/pincode-search"
  },
  {
    component: HubSearch,
    route: "/hub-search"
  },
  {
    component: CPSearch,
    route: "/cp-search"
  },
  {
    component: ShipmentDetails,
    route: "/shipment-details-ui"
  }
  ,
  {
    component: BagDetails,
    route: "/bag-details-ui"
  }
];
